
<template lang="pug">
q-page.fit
  .absolute-full.column

    //- ツールバー
    .col-auto
      .flex.justify-between
        .flex.items-center.q-ma-xs

          q-btn.q-mx-xs(
            flat
            @click="onClickChangeAspect"
          ) 表示切替

          q-btn-dropdown.q-mx-xs(
            flat
            split
            label="初期化"
            @click="onClickMakeShift(-1)"
          )
            q-list(link)
              q-item(
                v-close-overlay
                @click.native="onClickMakeShift(0)"
              )
                q-item-main: q-item-tile クリアする
              //- q-item(
              //-   v-close-overlay
              //-   @click.native="onClickMakeShift(3)"
              //- )
              //-   q-item-main: q-item-tile 旧方式で作成

          q-btn-dropdown.q-mx-xs(
            flat
            split
            label="印刷"
            @click="onClickPrint"
          )
            q-list(link)
              q-item(
                v-close-overlay
                @click.native="onClickPrintMulti"
              )
                q-item-main: q-item-tile まとめて

        //- 予測
        ShiftsEstimates.shifts-toolbar-right.q-ma-xs(
          ref="estimates"
          :storeCode="storeCode"
          :floorCode="floorCode"
          :date="date"
          @change="onChangeEstimates"
          @refresh="refresh"
        )

    //- グリッド
    .col.grid
      .grid__table(
        v-show="0 < cols.length && 0 < rows.length"
        ref="table"
        :style="gridTableStyle"
        @mousedown.left.stop="onMouseDownScroll"
      )
        .grid__thead

          //- コーナー
          .grid__corner-area(@contextmenu.prevent)
            .grid__tr
              .grid__corner(:style="[gridCornerStyle, columnHeaderStyle0]") 時
            //- .grid__tr
            //-   .grid__corner(:style="[gridCornerStyle, columnHeaderStyle0]") 分
            .grid__tr
              .grid__corner(:style="[gridCornerStyle, columnHeaderStyle0]") 予測客数：{{estimateSum||'なし'}}
            //- .grid__tr
            //-   .grid__corner(:style="[gridCornerStyle, columnHeaderStyle0]") 確保

            .grid__tr
              .grid__corner.shifts__column-surpluses(:style="[gridCornerStyle, columnHeaderStyle0]") 余剰

                //- 余剰凡例tip
                q-tooltip.app__tooltip(
                  anchor="bottom right"
                  self="top right"
                )
                  div 余剰の凡例 (RE合計が来客数に対して)
                  div Ｘ：レジ余り過大(+20人以上)
                  div △：レジ余り　　(+10〜+19人)
                  div ◯：適正　　　　(-10〜+9人)
                  <div><span style="color:red">▽</span>：レジ不足　　(-20〜-11人)</div>
                  <div><span style="color:red">Ｘ</span>：レジ不足過大(-21人以下)</div>

            //- 必要台数概算
            .grid__tr
              .grid__corner(:style="[gridCornerStyle, columnHeaderStyle0]") 必要台数概算(RE={{ colApproxRE }})

            .grid__tr
              .grid__corner.shifts__column-assignees(:style="[gridCornerStyle, columnHeaderStyle0]") レジ台数
            .grid__tr
              .grid__corner.shifts__row-sums(:style="[gridCornerStyle, columnHeaderStyle1]") 総人時：{{allSum|hourSum}}

                //- 種類別累計時間tip
                q-tooltip.app__tooltip(
                  :disable="typeSums.length === 0"
                  anchor="bottom left"
                  self="top left"
                )
                  table
                    tr(v-for="typ of typeSums")
                      td {{typ.label}}
                      td ：
                      td.text-right {{typ.sum|hour}}h

              .grid__corner(:style="[gridCornerStyle, columnHeaderStyle1]") 未割当：{{colIdleSum}}

          //- 列ヘッダ
          .grid__column-header-area(@contextmenu.prevent)
            .grid__tr
              .grid__column-header.grid__left(
                v-for="col of colHours"
                :style="[gridColumnHeaderStyle, columnHeaderStyle0, {width: grid.cellW * col.colspan  + 'px', paddingLeft: '8px'}]"
              ) {{col.label}}
            //- .grid__tr
            //-   .grid__column-header.grid__center(
            //-     v-for="minute of colMinutes"
            //-     :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
            //-   ) {{minute}}
            .grid__tr
              .grid__column-header.grid__center(
                v-for="estimate of colEstimates"
                :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
              ) {{estimate|unit}}
            //- .grid__tr
            //-   .grid__column-header.grid__center(
            //-     v-for="capacity of colCapacities"
            //-     :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
            //-   ) {{capacity|unit}}
            .grid__tr
              .grid__column-header.grid__center.shifts__column-surpluses(
                v-for="surplus of colSurpluses"
                :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
              )
                ShiftsSurplusMark(:value="surplus")

            //- 必要台数概算
            .grid__tr
              .grid__column-header.grid__center.shifts__column-surpluses(
                v-for="colApprox of colApproxes"
                :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
              ) {{colApprox|unit}}

            .grid__tr
              .grid__column-header.grid__center.shifts__column-assignees(
                v-for="colSum of colSums"
                :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
              ) {{colSum|unit}}
            .grid__tr
              .grid__column-header.grid__center(
                v-for="colIdle of colIdles"
                :style="[gridColumnHeaderStyle, columnHeaderStyle0]"
              ) {{colIdle|unit}}

        //- 行ヘッダ
        .grid__row-header-area(@contextmenu.prevent)
          .grid__tr(v-for="(row, y) of rows")
            .grid__row-header.grid__left(
              :style="[gridRowHeaderStyle, rowHeaderStyle0]"
              @contextmenu="(e) => onContextMenuDailyPeople(e, row, y)"
            ) {{row.model.name}}
            .grid__row-header.grid__center(
              :style="[gridRowHeaderStyle, rowHeaderStyle1]"
              @contextmenu="(e) => onContextMenuDailyPeople(e, row, y)"
            ) {{row.header1}}
            .grid__row-header.shifts__row-sums(:style="[gridRowHeaderStyle, rowHeaderStyle2]") {{rowSums[y]|hour}}

        //- セル
        .grid__cell-area(
          ref="content"
          @contextmenu="onContextMenuDefault"
        )
          grid-cells(
            :grid="grid"
            :rows="rows"
          )

          ShiftsItem(
            v-for="item of items"
            :key="item.id"
            :grid="grid"
            :item="item"
            @focus.native="setItemFocus(item)"
            @contextmenu="onContextMenuItem"
            @mousedown="onMouseDownItemMove"
            @mousedownleftedge="onMouseDownItemResizeLeft"
            @mousedownrightedge="onMouseDownItemResizeRight"
          )

        //- コンテキストメニュー
        ContextMenu(ref="contextMenu")

      //- メモ入力
      .shifts__memo(@mousedown.left.stop="onMouseDownScroll")
        pre.shifts__memo-text(v-if="store != null && store.memo !== ''") {{ store.memo }}
        q-btn.shifts__memo-btn(@click="onClickMemo") メモ編集

  //- 割当選択ポップアップ
  q-modal(
    ref="assignmenu"
    minimized
  )
    q-list(
      dense
      highlight
      v-close-overlay
    )
      q-list-header 割当を選択
      q-item(
        v-for="(assignee, index) of assignees"
        :key="assignee.model.code" /* 注意: code は person_code または task_code のエイリアス */
        @click.native="onSelectAssignMenu(index)"
      )
        q-item-main
          q-item-tile {{assignee.model.label}}

  //- 日付範囲ポップアップ
  PopupDateRange(
    ref="dateRange"
    @confirm="onClickPrintMultiConfirm"
  )

  //- 出退勤時間の入力
  PopupTimeRange(
    ref="popupDailyPeople"
    :min="store == null ? '' : store.display_begin_time"
    :max="store == null ? '' : store.display_end_time"
    @confirm="dailyPeopleConfirm"
  )
    template(slot-scope="{params}")
      q-btn.q-mx-sm(
        color="secondary" flat
        @click="dailyPeopleOff(params)"
      ) 休み

      q-btn.q-mx-sm(
        v-if="params.regular"
        color="secondary" flat
        @click="dailyPeopleRegular(params)"
      ) 通常 {{params.regular.begin|time}}〜{{params.regular.end|time}}

  //- メモ入力
  ShiftsMemo(
    ref="popupMemo"
    @confirm="onConfirmMemo"
  )
</template>

<script>
import {clamp, range} from 'lodash-es'

import {dateFilter, stepFrom, stepFromCeil, stepToString, stepFilter} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'
import DailyStore from 'models/DailyStore'
import DailyPerson from 'models/DailyPerson'
import Task from 'models/Task'

import ShiftsEstimates from './ShiftsEstimates'
import ShiftsSurplusMark from './ShiftsSurplusMark'
import ContextMenu from 'components/ContextMenu'
import ShiftsItem from './ShiftsItem'
import PopupDateRange from 'components/PopupDateRange'
import ShiftsMemo from './ShiftsMemo'

import AxiosMixin from 'mixins/axios'
import GridBaseMixin from 'mixins/GridBaseMixin'
import ShiftsSum from './ShiftsSum'
import ShiftsApprox from './ShiftsApprox'
import ShiftsDailyPeople from './ShiftsDailyPeople'

const disabledCell = Object.freeze({disabled: true, style: {backgroundColor: '#00000020'}})

export default {
  components: {ShiftsEstimates, ShiftsSurplusMark, ContextMenu, ShiftsItem, PopupDateRange, ShiftsMemo},
  mixins: [AxiosMixin, GridBaseMixin, ShiftsSum, ShiftsApprox, ShiftsDailyPeople],

  props: {
    storeCode: null,
    floorCode: null,
    date:      String,
    aspect:    String,
  },

  data() {
    return {
      grid: {
        cellW:     29,
        cellH:     25,
        headerW:  160,
        headerH:   25 * 5,
        paddingW:  20,
        paddingH:  20,
      },

      columnHeaderStyle0:  Object.freeze({height: '25px'}),
      columnHeaderStyle1:  Object.freeze({width:  '80px', height: '25px'}),
      rowHeaderStyle0:     Object.freeze({width:  '60px'}),
      rowHeaderStyle1:     Object.freeze({width:  '70px'}),
      rowHeaderStyle2:     Object.freeze({width:  '30px'}),

      store: null,
      people: [],
      tasks: [],
      shifts: [],

      rows: [],
      assignees: [],
      items: [],

      estimates: [],
      estimateSum: 0,

      dragging: null,
      itemFocused: null,
      assignMenuCallback: null,
    }
  },

  computed: {
    ...mapAuto(['timeStepMinutes', 'stores']),

    viewKey() {
      return Object.values(this.$props).some(v => v == null)
        ? null
        : this.storeCode + '/' + this.floorCode + '/' + this.date
    },

    displayBeginStep() {
      return this.store == null ? null : stepFrom(this.store.display_begin_time)
    },

    displayEndStep() {
      return this.store == null ? null : stepFromCeil(this.store.display_end_time)
    },

    cols() {
      return range(this.displayBeginStep, this.displayEndStep)
    },

    colHours() {
      const hours = []
      let step = this.displayBeginStep
      if(step < this.displayEndStep) {
        let hour = {label: stepFilter(step, 'm'), colspan: 1}
        hours.push(hour)
        while(++step < this.displayEndStep) {
          const label = stepFilter(step, 'm')
          if(label !== hour.label) {
            hour = {label, colspan: 1}
            hours.push(hour)
          }
          else {
            ++hour.colspan
          }
        }
      }
      return hours
    },

    colMinutes() {
      return this.cols.map(step => stepFilter(step, 'ss'))
    },

    colEstimates() {
      const cols = this.cols.map(() => 0)
      for(const estimate of this.estimates) {
        const step = stepFrom(estimate.time)
        if(this.displayBeginStep <= step && step < this.displayEndStep) {
          cols[step - this.displayBeginStep] = estimate.customers
        }
      }
      return cols
    },

    colSurpluses() {
      return this.colCapacities.map((v, i) => v == null ? null : v - this.colEstimates[i])
    },

    personMap() {
      return this.people.reduce((a, {model}, index) => ({...a, [model.person_code]: {model, index}}), {})
    },

    taskMap() {
      return this.tasks.reduce((a, {model}, index) => ({...a, [model.task_code]: {model, index}}), {})
    },
  },

  watch: {
    viewKey() {
      this.refresh()   .catch(() => {console.warn('refresh reject in viewKey')})
    },

    aspect() {
      this.updateItems()
    },
  },

  mounted() {
    if(['person', 'task'].every(v => v != this.aspect)) {
      this.$store.commit('route', {params: {aspect: 'person'}})
    }
    this.refresh()   .catch(() => {console.warn('refresh reject in mounted')})

    //
    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup', this.onMouseUp)
  },

  beforeDestroy() {
    document.removeEventListener('mouseup', this.onMouseUp)
    document.removeEventListener('mousemove', this.onMouseMove)
  },

  methods: {

    onClickChangeAspect() {
      this.$store.commit('route', {params: {aspect: this.aspect !== 'task' ? 'task' : 'person'}})
    },

    // 初期化
    async onClickMakeShift(algo) {
      try {
        if(this.storeCode && this.floorCode && this.date) {
          await this.$q.dialog({
            title:   'レジシフトの初期化：' + dateFilter(this.date),
            message: 'この日のレジシフトを初期化します。本当によろしいですか？',
            ok:      {label: '実行',       color: 'negative'},
            cancel:  {label: 'キャンセル', color: 'dark', flat: true},
          })

          await this.axios.put('/api/views/shifts/' + this.storeCode + '/' + this.floorCode + '/' +  this.date + '/make/' + algo)

          await this.refresh()
          await this.$refs.estimates.refresh()

          await this.$q.dialog({
            title:   '完了',
            message: 'レジシフトを初期化が完了しました。',
            ok:      'OK',
          })
        }
      }
      catch(e) {this.$handler(e)}
    },

    // 印刷
    onClickPrint() {
      window.open('/api/views/shifts/' + this.storeCode + '/' + this.floorCode + '/' +  this.date + '/' +  this.date + '/print')
    },

    onClickPrintMulti() {
      this.$refs.dateRange.show(this.date, {title: 'まとめてレジシフト印刷'})
    },

    onClickPrintMultiConfirm(begin_date, end_date) {
      window.open('/api/views/shifts/' + this.storeCode + '/' + this.floorCode + '/' +  begin_date + '/' + end_date + '/print')
      this.$refs.dateRange.hide()
    },

    // コンテキストメニュー

    onContextMenuDefault(e) {
      this.$refs.contextMenu.show(e, [{
        label: '予定を作成',
        onClick: () => {
          this.assignMenuCallback = index => {
            const rect     = this.$refs.content.getBoundingClientRect()
            const begin    = Math.floor((e.clientX - rect.left) / this.grid.cellW)
            const end      = begin + 2
            const row      = Math.floor((e.clientY - rect.top) / this.grid.cellH)
            const assignee = index
            this.insertItem({begin, end, row, assignee})   .catch(() => {console.warn('insert reject in onContextMenuDefault')})
          }
          this.$refs.assignmenu.show()
        },
      }])
    },

    onContextMenuItem(e, item) {

      // CTRL+クリックでシフトを分割する (コンテキストメニューは開かない)
      if(e.ctrlKey) {
        return
      }

      //
      const options = []

      options.push({
        label: '割当を変更',
        onClick: () => {
          this.assignMenuCallback = index => {
            item.assignee = index
            this.updateItem(item)   .catch(() => {console.warn('updateItem reject in onContextMenuItem')})
          }
          this.$refs.assignmenu.show()
        },
      })

      const rect = this.$refs.content.getBoundingClientRect()
      const time = Math.floor((e.clientX - rect.left) / this.grid.cellW)
      if(item.begin < time && time < item.end - 1) {
        options.push({
          label: 'ここで分割',
          onClick: () => {
            this.insertItem({
              begin:    time + 1,
              end:      item.end,
              row:      item.row,
              assignee: item.assignee,
            })   .catch(() => {console.warn('insert reject in onContextMenuItem')})
            item.end = time
            this.updateItem(item)   .catch(() => {console.warn('updateItem reject in onContextMenuItem #2')})
          },
        })
      }

      options.push({
        label: '予定を削除',
        onClick: async () => {
          try {
            await this.$q.dialog({
              title: '予定の削除',
              message: '予定を削除してよろしいですか？',
              ok:     {label: '削除',       color: 'negative', flat: true},
              cancel: {label: 'キャンセル', color: 'dark',     flat: true},
            })

            this.deleteItem(item)   .catch(() => {console.warn('deleteItem reject in onContextMenuItem')})
          }
          catch(e) {this.$handler(e)}
        },
      })

      this.$refs.contextMenu.show(e, options)
    },

    onSelectAssignMenu(index) {
      if(this.assignMenuCallback) {
        this.assignMenuCallback(index)
      }
    },

    // マウスイベント

    onMouseDownScroll(e) {
      this.setItemFocus(null)
      const container = this.$refs.table.parentNode
      const offsetX = container.scrollLeft + e.screenX
      const offsetY = container.scrollTop + e.screenY
      this.dragging = {
        onMouseMove: e => {
          container.scrollLeft = offsetX - e.screenX
          container.scrollTop = offsetY - e.screenY
        },
      }
    },

    onMouseDownItemMove(e, item) {
      // CTRL+クリックでシフトを分割する
      if(e.ctrlKey) {
        const rect = this.$refs.content.getBoundingClientRect()
        const time = Math.floor((e.clientX - rect.left) / this.grid.cellW)
        if(item.begin < time && time < item.end - 1) {
          this.insertItem({
            begin:    time + 1,
            end:      item.end,
            row:      item.row,
            assignee: item.assignee,
          })   .catch(() => {console.warn('insert reject in onMouseDownItemMove')})
          item.end = time
          this.updateItem(item)   .catch(() => {console.warn('updateItem reject in onMouseDownItemMove')})
        }
        return
      }

      //
      const rect = this.$refs.content.getBoundingClientRect()
      const offset = Math.floor((e.clientX - rect.left) / this.grid.cellW) - item.begin
      const width = item.end - item.begin
      this.dragging = {
        onMouseMove: e => {
          item.begin = clamp(Math.floor((e.clientX - rect.left) / this.grid.cellW) - offset, 0, this.cols.length - width)
          item.end = item.begin + width
          item.row = clamp(Math.floor((e.clientY - rect.top) / this.grid.cellH), 0, this.rows.length - 1)
        },
        onMouseUp: () => {
          this.updateItem(item)   .catch(() => {console.warn('updateItem reject in onMouseDownItemMove #2')})
        },
      }
    },

    onMouseDownItemResizeLeft(e, item) {
      const rectLeft = this.$refs.content.getBoundingClientRect().left
      this.dragging = {
        onMouseMove: e => {
          item.begin = clamp(Math.floor((e.clientX - rectLeft) / this.grid.cellW + .5), 0, item.end - 1)
        },
        onMouseUp: () => {
          this.updateItem(item)   .catch(() => {console.warn('updateItem reject in onMouseDownItemResizeLeft')})
        },
      }
    },

    onMouseDownItemResizeRight(e, item) {
      const rectLeft = this.$refs.content.getBoundingClientRect().left
      this.dragging = {
        onMouseMove: e => {
          item.end = clamp(Math.floor((e.clientX - rectLeft) / this.grid.cellW + .5), item.begin + 1, this.cols.length)
        },
        onMouseUp: () => {
          this.updateItem(item)   .catch(() => {console.warn('updateItem reject in onMouseDownItemResizeRight')})
        },
      }
    },

    onMouseMove(e) {
      if(this.dragging && this.dragging.onMouseMove) {
        this.dragging.onMouseMove(e)
      }
    },

    onMouseUp(e) {
      if(this.dragging && e.button == 0) { // 左ボタンドラッグのみ対応
        if(this.dragging.onMouseUp) {
          this.dragging.onMouseUp()
        }
        this.dragging = null
      }
    },

    setItemFocus(item) {
      if(this.itemFocused) {
        this.itemFocused.state = null
      }
      if(this.itemFocused = item) {
        this.itemFocused.state = 'focus'
      }
    },

    // DATA
    async refresh() {
      try {
        if(this.viewKey != null) {

          // 表示を一旦クリアする
          this.people = []
          this.tasks = []

          //
          const {data} = await this.axios.get('/api/views/shifts/' + this.viewKey)

          this.store = new DailyStore(data.dailyStore)

          // 個人の配列を作成する
          this.people = data.dailyPeople.map(person => {
            const model = new DailyPerson(person)

            // 個人の勤務時間に基づいてセル背景色を塗り分ける
            let cells
            if(model.isTimeValid) {
              cells = this.cols.map(step => stepFrom(model.begin_time) <= step && step < stepFromCeil(model.end_time) ? {} : disabledCell)
            }
            else {
              cells = this.cols.map(() => disabledCell)
            }

            return {model, cells}
          })

          // 行の配列を作成する
          // const estimates = this.$refs.estimates.makeEstimates(this.date, this.cols, data)

          this.tasks = data.tasks.map(task => {
            const model = new Task(task)

            // 予測に基づいてセル背景色を塗り分ける
            let cells
            // const re = data.dailyStore['re' + task.type]
            // if(re) {
            //   cells = this.cols.map((time, index) => {
            //     const disabled = estimates[index] <= 0
            //     estimates[index] -= re
            //     return disabled ? disabledCell : {}
            //   })
            // }
            // else {
              cells = this.cols.map(() => ({}))
            // }

            return {model, cells}
          })

          // 対象(シフト)の配列を作成する
          const shifts = []
          for(const shift of data.shifts) {
            const person = this.personMap[shift.person_code]
            if(person == null) continue

            const task = this.taskMap[shift.task_code]
            if(task == null) continue

            shifts.push({
              id:     shift.id,
              person: person.index,
              task:   task.index,
              begin:  stepFrom(shift.begin_time)   - this.displayBeginStep,
              end:    stepFromCeil(shift.end_time) - this.displayBeginStep,
            })
          }

          this.shifts = shifts

          //
          this.updateItems()
        }
      }
      catch(e) {this.$handler(e)}
    },

    // items配列を更新する
    updateItems() {
      if(this.aspect != 'person') {
        this.rows = this.tasks.filter(task => !task.model.hidden).map(task => {
          const re = this.store['re' + task.model.type]
          return {
            ...task,
            header1: re ? 'RE ' + re : '-',
          }
        })
        this.assignees = this.people
      }
      else {
        this.rows = this.people.map(person => ({
          ...person,
          header1: person.model.timeLabel || '-',
        }))
        this.assignees = this.tasks
      }

      const items = []
      if(this.aspect != 'person') {
        for(const [index, shift] of this.shifts.entries()) {
          const person = this.assignees[shift.person]
          const task   = this.rows[shift.task]
          if(person != null && task != null) {
            items.push({
              label:    person.model.short_label,
              row:      shift.task,
              assignee: shift.person,

              id:       shift.id,
              begin:    shift.begin,
              end:      shift.end,
              state:    null,
              color:    null,
              index,

              hidden:     false,
              isRegister: task.model.isRegister,

              get task() {return this.row}, //####
            })
          }
          else {
            // shifts整合性エラー報告
            // console.warn('shifts.vue整合性エラー') // eslint-disable-line no-console // 休憩を無いことにしているので、ここで整合性検出はできない
          }
        }
      }
      else {
        for(const [index, shift] of this.shifts.entries()) {
          const task = this.assignees[shift.task]
          if(task != null) {
            items.push({
              label:    task.model.short_label,
              row:      shift.person,
              assignee: shift.task,

              id:       shift.id,
              begin:    shift.begin,
              end:      shift.end,
              state:    null,
              color:    null,
              index,

              hidden:     task.model.hidden,
              isRegister: task.model.isRegister,

              get task() {return this.assignee}, //####
            })
          }
          else {
            // shifts整合性エラー報告
            console.warn('shifts.vue整合性エラー') // eslint-disable-line no-console
          }
        }
      }
      this.items = items

      if(this.itemFocused) {
        this.itemFocused = this.items.find(o => o.id === this.itemFocused.id)
        if(this.itemFocused) {
          this.itemFocused.state = 'focus'
        }
      }

      this.validateItems()
    },

    // items配列を検証して着色する
    // TODO: shifts を deep watch したほうがよい？
    validateItems() {
      const rows      = this.rows     .map(() => this.cols.map(() => []))
      const assignees = this.assignees.map(() => this.cols.map(() => []))
      for(const [i, item] of this.items.entries()) {
        if(rows[item.row] != null) {
          const row = rows[item.row]
          const assignee = assignees[item.assignee]

          for(let t = item.begin; t < item.end; ++t) {
            if(row[t] != null) row[t].push(i)
            if(!item.hidden) assignee[t].push(i)
          }
        }
      }

      for(const item of this.items) {
        item.color = item.hidden ? 'hidden' : (item.isRegister ? null : 'non-register')
      }

      for(const item of this.items) {
        if(rows[item.row] != null &&
          (this.rows     [item.row     ].cells.slice(item.begin, item.end).find(o => o.disabled)
          || this.assignees[item.assignee].cells.slice(item.begin, item.end).find(o => o.disabled))) {
          item.color = 'warning'
        }
      }

      for(const perspective of [rows, assignees]) {
        for(const cols of perspective) {
          for(const indices of cols) {
            if(1 < indices.length) {
              for(const i of indices) {
                this.items[i].color = 'error'
              }
            }
          }
        }
      }

      // 行/列の累計情報を作成する
      this.makeSums(this.cols, this.rows, this.items)
      this.makeTypeSums(this.tasks, this.shifts)

      // 必要台数概算を作成する
      this.makeApprox()
    },

    // item要素を新規作成する
    makeShift({begin, end, row, assignee}) {
      return this.aspect != 'person'
        ? {
          begin,
          end,
          person: assignee,
          task: row,
        }
        : {
          begin,
          end,
          person: row,
          task: assignee,
        }
    },

    async insertItem(item) {
      try {
        const shift = this.makeShift(item)
        const apiData = {
          date:        this.date,
          store_code:  this.store.store_code,
          floor_code:  this.store.floor_code,
          begin_time:  stepToString(shift.begin + this.displayBeginStep),
          end_time:    stepToString(shift.end   + this.displayBeginStep),
          person_code: this.people[shift.person].model.person_code,
          task_code:   this.tasks [shift.task  ].model.task_code,
        }

        const {data: {id}} = await this.axios.post('/api/shifts', apiData)
        this.shifts.push({...shift, id})
        this.updateItems()
      }
      catch(e) {this.$handler(e)}
    },

    // item要素を更新する
    async updateItem(item) {
      try {
        const modifier = this.makeShift(item)
        const modifiee = this.shifts[item.index]
        const apiData = {}
        for(const [prop, setApiData] of [
          ['begin',  v => {apiData.begin_time  = stepToString(v + this.displayBeginStep)}],
          ['end',    v => {apiData.end_time    = stepToString(v + this.displayBeginStep)}],
          ['person', v => {apiData.person_code = this.people[v].model.person_code}],
          ['task',   v => {apiData.task_code   = this.tasks [v].model.task_code  }],
        ]) {
          if(modifiee[prop] !== modifier[prop]) {
            modifiee[prop] = modifier[prop]
            setApiData(modifier[prop])
          }
        }
        if(Object.keys(apiData).length) {
          item.label = this.assignees[item.assignee].model.short_label
          this.updateItems()
          await this.axios.put('/api/shifts/' + item.id, apiData)
        }
      }
      catch(e) {this.$handler(e)}
    },

    // item要素を削除する
    async deleteItem(item) {
      try {
        this.shifts.splice(item.index, 1)
        this.updateItems()
        await this.axios.delete('/api/shifts/' + item.id)
      }
      catch(e) {this.$handler(e)}
    },

    // 予測が変更された
    onChangeEstimates(data) {
      this.estimates = data.estimates
      this.estimateSum = data.estimateSum
    },

    // メモ入力
    onClickMemo() {
      if (this.store != null) {
        this.$refs.popupMemo.show(this.store.memo, {
          title: `${this.store.label} ${dateFilter(this.date)}`,
        })
      }
    },

    async onConfirmMemo(text) {
      await this.axios.put('/api/daily_stores/' + this.store.id, {memo: text})
      this.store.memo = text
      this.$refs.popupMemo.hide()
    },
  },
}
</script>

<style lang="sass">

// ツールバー予測UI部分は2段になった場合でも右寄せにする
.shifts-toolbar-right
  margin-left: auto

//
.shifts__row-sums
  background-color: white

// 余剰columnヘッダ
.shifts__column-surpluses
  background-color: white
  // font-weight: bold

// 割当人数columnヘッダ
.shifts__column-assignees
  background-color: mix(rgb(192, 216, 255), white, 80%)

.shifts__memo
  left: 0
  padding: 0 1em 2em
  position: sticky

.shifts__memo-text
  border: 1px solid #a0a0a0
  border-radius: 0.5em
  font-size: 1.125rem
  margin: 0 0 1em
  padding: 1em
  white-space: pre-wrap
  word-break: break-all
</style>
